import axios from "axios";
import Const from "../utils/constant";

const axiosInstance = axios.create({
  baseURL: Const.API.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(Const.STORAGE_KEYS.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid — clear session and redirect to login
      const isLoginRequest = error.config?.url?.includes("/login");
      if (!isLoginRequest) {
        localStorage.removeItem(Const.STORAGE_KEYS.USER);
        localStorage.removeItem(Const.STORAGE_KEYS.TOKEN);
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

